export const AR_STATUS = {
    INITIATED_MEASUREMENT: "0",
    STARTED_MEASUREMENT: "1",
    EXIT_MEASUREMENT: "2",
    AR_DEVICE_SUPPORTED_STATUS: "3",
    CLEAR_MEASUREMENT: "4",
    UNDO_MEASUREMENT: "5",
    CANCEL_MEASUREMENT: "6",
};

export const AR_MEASUREMENT_ACTION = {
    NOT_SUPPORT_AR: "1",
    APP_NOT_INSTALLED: "2",
    NEEDS_TO_UPDATE_APP: "3",
    SUPPORTED_READY_TO_START: "4",
    UNSET_POPUP: "5",
};

export const AR_STATUS_LIST = {
    0: "ready_for_measurement",
    1: "more_light_required",
    2: "move_further_away",
    3: "slow_down",
    4: "tacking_not_available",
    5: "camera_use_bu_another_app",
    6: "move_device_to_start",
    7: "find_surface_to_measure",
};
